import { render, staticRenderFns } from "./UISettings.vue?vue&type=template&id=d59342b2&scoped=true"
import script from "./UISettings.vue?vue&type=script&lang=js"
export * from "./UISettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59342b2",
  null
  
)

export default component.exports